<template>
  <div class="box7-page">
    <div class="fcp-title">不只是认证，更是热门的前沿技术</div>
    <div class="fcp-text">课程融入传智教育自主研发大数据热门内容，即使不用来考证，<br/>您也可以学到前沿核心技术知识用于工作中</div>
    <div class="list-mask">
      <ul>
        <li 
          v-for="(item, index) in list" 
          :key="index"
          :style="{backgroundImage: `url(${require('../../../assets/coursePage/fcp/box7/card-bg-0' + (index + 1) + '.png')})`}"
        >
          <h2>{{ item.title }}</h2>
          <p v-html="item.info"></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        list:[
          {
            title: '技术',
            info: '手把手教授大数据领域热门知识点，辅以<br/>泛电商应用场景讲解，深入5大主题流程分<br/>析，让您掌握核心前沿技术，即使不考<br/>证，也能用在工作中。'
          },
          {
            title: '理论',
            info: '项目背景介绍、BI报表开发需求分析、BI与<br/>运营桥梁搭建、决策系统&管理系统介绍<br/>等，延伸+扩展其他BI工具的使用，让您知<br/>其然更知其所以然。'
          },
          {
            title: '实战',
            info: 'FineReport、MySQL、Tomcat、Kettle四<br/>大模块讲解+泛电商行业案例实操，真正掌<br/>握企业数据管理、分析等能力。'
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.box7-page{
  padding: 80px 0;
  background-image: url(../../../assets/coursePage/fcp/box7/box7-bg.png);
  background-size: cover;
  .list-mask{
    width: 100%;
    margin-top: 48px;
    overflow-x: auto;
    overflow-y: hidden;
    height: 380px;
    ul{
      max-width: 1888px;
      height: 420px;
      display: flex;
      padding: 0 32px 40px;
      overflow-x: auto;
      overflow-y: hidden;
      box-sizing: border-box;
      li{
        min-width: 606px;
        width: 606px;
        height: 380px;
        padding: 48px 0 0 48px;
        margin-right: 32px;
        box-sizing: border-box;
        background-size: 100% 100%;
        h2{
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #161A1D;
          line-height: 52px;
        }
        p{
          margin-top: 16px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1F375F;
          line-height: 46px;
        }

        &:last-child{
          margin: 0;
        }
      }
    }
  }
}
</style>